<template>
    <span class="sub-menu-divider">
    </span>
</template>

<script>
    export default {
        name: `sub-menu-divider`
    }
</script>

<style lang="scss" scoped>
    .sub-menu-divider {
        display: inline-block;
        width: 4px;
        margin: 15px 3px;
        background: rgba(white, 0.1);
        border-radius: 4px;
        height: 70px;
        vertical-align: top;
    }
</style>
